import type React from 'react';

import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

import {
  ControlBarContainer,
  ControlsContainer,
  VolumeSliderContainer,
  // VolumeSlider,
  VolumeArea,
  VOLUME_SLIDER_CONTAINER_CLASS,
  ControlsGroup,
  ControlsBackgroundOverlay,
} from './DesktopControls.style';
import ElapsedAndTotalTime from '../ElapsedAndTotalTime';
import {
  getPlayPauseIcon,
  getMuteIcon,
  getOnPlayPauseClick,
  getFullscreenButtonIcon,
} from '../Mp3KbpPlayerControls/utils';
import PlayerButton from '../PlayerButton';
import TimeSlider from '../TimeSlider';

export const CONTROL_BAR_CLASS_NAME = 'controlBar';
export const PLAYING_CLASS_NAME = 'playing';

interface Props {
  isPlaying: boolean;
  handlePlay: () => void;
  handlePause: () => void;
  handleRestartSong: () => void;
  isPlayNextSongDisabled: boolean;
  handlePlayNextSong: () => void;
  songDuration: number | null;
  songFutureTime: number | null;
  setSongFutureTime: (futureTime: number | null) => void;
  bufferedTimeRanges: TimeRanges | null;
  isMuted: boolean;
  handleMute: () => void;
  currentVolume: number;
  handleVolumeChange: (volume: number) => void;
  setLastPositiveVolume: (volume: number) => void;
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  videoElement: HTMLVideoElement;
}

const DesktopControls: React.FC<Props> = ({
  isPlaying,
  handlePlay,
  handlePause,
  handleRestartSong,
  isPlayNextSongDisabled,
  handlePlayNextSong,
  songDuration,
  songFutureTime,
  setSongFutureTime,
  bufferedTimeRanges,
  isMuted,
  handleMute,
  currentVolume,
  isFullscreen,
  toggleFullscreen,
  videoElement,
}) => {
  const PlayPauseIcon = getPlayPauseIcon(isPlaying);
  const onPlayPauseClick = getOnPlayPauseClick(isPlaying, handlePause, handlePlay);
  const MuteIcon = getMuteIcon(isMuted, currentVolume);
  const FullscreenButtonIcon = getFullscreenButtonIcon(isFullscreen);

  return (
    <ControlBarContainer
      className={`${CONTROL_BAR_CLASS_NAME} ${isPlaying ? PLAYING_CLASS_NAME : ''}`}
    >
      {songDuration && (
        <TimeSlider
          songDuration={songDuration}
          songFutureTime={songFutureTime}
          setSongFutureTime={setSongFutureTime}
          bufferedTimeRanges={bufferedTimeRanges}
          videoElement={videoElement}
        />
      )}
      <ControlsContainer>
        <ControlsGroup>
          <PlayerButton Icon={SkipPreviousIcon} onClick={handleRestartSong} />
          <PlayerButton Icon={PlayPauseIcon} onClick={onPlayPauseClick} />
          <PlayerButton
            Icon={SkipNextIcon}
            onClick={handlePlayNextSong}
            isDisabled={isPlayNextSongDisabled}
          />
          <VolumeArea>
            <PlayerButton Icon={MuteIcon} onClick={handleMute} />
            <VolumeSliderContainer className={VOLUME_SLIDER_CONTAINER_CLASS}>
              {/* <VolumeSlider
                min={0}
                max={1}
                step={0.05}
                value={isMuted ? 0 : currentVolume}
                valueLabelDisplay="off"
                onChange={(_, value) => handleVolumeChange(value as number)}
                onChangeCommitted={(_, value) => {
                  if ((value as number) > 0) {
                    setLastPositiveVolume(value as number);
                  }
                }}
              /> */}
            </VolumeSliderContainer>
            <ElapsedAndTotalTime songDuration={songDuration} videoElement={videoElement} />
          </VolumeArea>
        </ControlsGroup>
        <ControlsGroup>
          <PlayerButton Icon={FullscreenButtonIcon} onClick={toggleFullscreen} />
        </ControlsGroup>
      </ControlsContainer>
      <ControlsBackgroundOverlay />
    </ControlBarContainer>
  );
};

export default DesktopControls;
